import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { forwardRef } from 'react';
import classNames from 'classnames';
import styled from 'styled-components';
import { toPx } from '../utils/Styles';
const ScrollWrapper = styled.div.withConfig({
  displayName: "UISection__ScrollWrapper",
  componentId: "ia5pay-0"
})(["height:", ";&&{", ";}& >:last-child{margin-bottom:0;}"], ({
  height
}) => height && toPx(height), ({
  flush
}) => flush && `margin-bottom: 0`);
const UISection = /*#__PURE__*/forwardRef((props, ref) => {
  const {
    className,
    use
  } = props,
        rest = _objectWithoutPropertiesLoose(props, ["className", "use"]);

  return /*#__PURE__*/_jsx(ScrollWrapper, Object.assign({}, rest, {
    className: classNames("is--module namespaced-hack-section", className, use === 'island' && 'is--island'),
    ref: ref
  }));
});
UISection.propTypes = {
  children: PropTypes.node,
  flush: PropTypes.bool.isRequired,
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  use: PropTypes.oneOf(['default', 'island']).isRequired
};
UISection.defaultProps = {
  flush: false,
  use: 'default'
};
UISection.displayName = 'UISection';
export default UISection;